import { LocaleTypeEnum } from "@/types/localization";

const SUPPORTED_LANGS = Object.values(LocaleTypeEnum) as string[];

/**
 * Validates a raw language value against the supported locale set
 * ({@link LocaleTypeEnum}) by its primary subtag, case-insensitively.
 *
 * Examples: "en-GB" -> EN, "CS" -> CS, "de" -> null, "" -> null.
 *
 * Returns the matching {@link LocaleTypeEnum} or `null` when unsupported, so
 * callers can skip a present-but-invalid signal and continue down the chain.
 */
export const normalizeToSupportedLang = (
  raw: string | null | undefined,
): LocaleTypeEnum | null => {
  if (!raw) return null;

  const primarySubtag = raw.toLowerCase().split("-")[0].trim();

  return SUPPORTED_LANGS.includes(primarySubtag)
    ? (primarySubtag as LocaleTypeEnum)
    : null;
};
